<template>
    <div v-if="appData.loaded" class="main-panel">
        <table v-if="disableOnlinePayment" class="alertfield">
            <tr v-if="pendingPaidReview" class="alertrecord" v-t="'message.info_paid_reviewing'"></tr>
            <tr v-else-if="pendingOnline" class="alertrecord">{{ getPendingOnlineAlertMessage() }}</tr>
            <tr v-else-if="pendingClosing" class="alertrecord" v-t="'message.info_not_confirm_settlement'"></tr>
            <tr v-else-if="paidDisable" class="alertrecord" v-t="'message.info_paid_disabled'"></tr>
        </table>
        <table height=100% width=100% cellpadding=0 cellspacing=0>
            <tr v-if="isEnablePurchase() && appData.basicContract.planType == 0" height="56px">
                <td v-if="appData.basicContract != null" colspan=2>
                    <div class="panel-command-box">
                        <div class="panel-command-box-left">
                            <span v-if="managementUserRights">
                                <span v-if="disableOnlinePayment">
                                    <el-tooltip effect="light" placement="top-start" >
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_cannot_change_license_by_credit_error')"></div>
                                        <el-button class="disable-command-button" style="width:200px">{{ getPurchaseCommandName() }}</el-button>
                                    </el-tooltip>
                                </span>
                                <span v-else>
                                    <el-button class="enable-command-button" style="width:200px" v-on:click="handlePurchaseLicense()">{{ getPurchaseCommandName() }}</el-button>
                                </span>
                            </span>
                            <span v-else>
                                <el-tooltip effect="dark" placement="top-start" >
                                    <div slot="content" style="text-align:left" v-html="$t('message.info_not_purchase_license')"></div>
                                    <el-button class="disable-command-button" style="width:200px">{{ getPurchaseCommandName() }}</el-button>
                                </el-tooltip>
                            </span>
                            <div v-if="pendingOnline" class="command-button">
                                <el-button style="width: 200px" v-on:click="resetPendingCreditProcess()" v-t="'message.action_confirm_settlement'"></el-button>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            <tr v-else-if="isEnablePurchase() && appData.basicContract.planType > 0 && pendingOnline" height="56px">
                <!---- Command button area for plan sales ----->
                <td colspan="2">
                    <div class="panel-command-box">
                        <div class="panel-command-box-left">
                            <div v-if="pendingOnline" class="command-button">
                                <el-button style="width: 200px" v-on:click="resetPendingCreditProcess()" v-t="'message.action_confirm_settlement'"></el-button>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            <tr height="100%">
                <div class="inner-panel">
                    <div class="license-title-box">
                        <div class="license-title-box-left">
                            <span v-t="'message.item_contract_information'"/>
                            <span v-if="(contractChangeOperation !=null) & isAutoUpdateContract()" style="padding-left:10px;color:#d55169">{{ getContractChangeNotice() }}</span>
                        </div>
                    </div>
                    <div v-if="appData.basicContract != null" class="license-table">
                        <table height=100% width=100% cellpadding=0 cellspacing=0>
                            <div class="license-item-value">
                                <!--- type of contract --->
                                <span style="width:300px;display:inline-block">{{ getDisplayContractName(appData.basicContract.purchasePeriodType) }}</span>
                                <template v-if="!isTrial()">
                                    <span v-if="appData.onlinePurchase && !pendingPaidReview">
                                        <span v-if="!isAutoUpdateContract() || disableOnlinePayment">
                                            <el-tooltip effect="dark" placement="top-start">
                                                <div v-if="disableOnlinePayment" slot="content" style="text-align:left" v-html="$t('message.hint_cannot_change_contract_by_credit_error')"></div>
                                                <div v-else slot="content" style="text-align:left" v-html="$t('message.hint_cannot_change_contract')"></div>
                                                <el-button class="auto-update-disabled" >{{ getContractChangeCommandName() }}</el-button>
                                            </el-tooltip>
                                        </span>
                                        <span v-else>
                                            <el-button class="auto-update" @click="showConfirmChangeContractTypeDialog()">{{ getContractChangeCommandName() }}</el-button>
                                        </span>
                                    </span>
                                </template>
                            </div>
                            <div v-if="!isTrial()" class="license-item-value">
                                <!--- status of contract --->
                                <span style="width:300px;display:inline-block">{{ getContractStatusName(appData.basicContract.state) }}</span>
                                <span v-if="appData.onlinePurchase && !isTrial() && !pendingPaidReview && isActivePlan()">
                                    <span v-if="contractChangeOperation != null || (pendingOnline || pendingClosing || paidDisable)">
                                        <el-tooltip effect="dark" placement="top-start">
                                            <div v-if="(pendingOnline || pendingClosing || paidDisable)" slot="content" style="text-align:left" v-html="$t('message.hint_cannot_disable_auto_update_by_credit_error')"></div>
                                            <div v-else slot="content" style="text-align:left" v-html="$t('message.hint_cannot_disable_auto_update')"></div>
                                            <el-button class="auto-update-disabled" >{{ getPurchaseContractActionName(appData.basicContract.state) }}</el-button>
                                        </el-tooltip>
                                    </span>
                                    <span v-else>
                                        <el-button class="auto-update" @click="showConfirmAutoUpdateDialog()">{{ getPurchaseContractActionName(appData.basicContract.state) }}</el-button>
                                    </span>
                                </span>
                            </div>
                            <div v-if="appData.basicContract.planType > 0" class="license-item-value">
                                <!-- type of plan --->
                                <span v-if="isActivePlan()" v-t="'message.item_contract_plan'"></span>
                                <span v-else v-t="'message.item_contract_plan_used'"></span>
                                ：{{ getDisplayPlanName() }}
                            </div>
                            <div class="license-item-value">
                                <!-- due date of contract --->
                                {{ getNextFlushDateName(appData.basicContract.state) }}：
                                <span v-if="appData.basicContract.state === 9">
                                    {{ getDisplayStartDateTime(appData.basicContract.purchasePeriodType) }}
                                </span>
                                <span v-else>
                                    {{ getDisplayExpireDateTime(appData.basicContract.purchasePeriodType) }}
                                </span>
                            </div>
                        </table>
                    </div>

                    <div v-if="isSeparately()">
                        <!---- ばら売りライセンス ---->
                        <div class="license-title-box">
                            <div v-if="appData.basicContract.planType == 0" class="license-title-box-left" v-t="'message.item_license_basic'"></div>
                            <div v-else class="license-title-box-left" v-t="'message.item_license_info'"></div>
                        </div>
                        <div class="license-table">
                            <table height=100% width=100% cellpadding=0 cellspacing=0>
                                <tr v-if="planLicenseContract.length > 0" class="license-record-header">
                                    <td class="license-item-title" width="30%" v-t="'message.item_license_name'"></td>
                                    <td class="license-item-title" width="20%">
                                        {{ getDescriptionOfCurrent() }}
                                        <el-tooltip effect="dark" placement="right">
                                            <div slot="content" style="text-align:left">{{ getTooltipOfCurrent() }}</div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </td>
                                    <td v-if="showPurchasedCount()" class="license-item-title" width="20%">
                                        {{ getDescriptionOfPurchasedCount() }}
                                        <el-tooltip effect="dark" placement="right">
                                            <div slot="content" style="text-align:left">{{ getTooltipOfPurchasedCount() }}</div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </td>
                                    <td v-if="showAvailableCount()" class="license-item-title" width="20%">
                                        {{ getDescriptionOfAvailableCount() }}
                                        <el-tooltip effect="dark" placement="right">
                                            <div slot="content" style="text-align:left">{{ getTooltipOfAvailableCount() }}</div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </td>
                                </tr>
                                <tr v-for="(planLicense,index) in planLicenseContract" :class="{'license-record-no-hover': (index < planLicenseContract.length - 1),'license-record-no-hover-bottom': (index === planLicenseContract.length - 1)}">
                                    <td v-if="isEnableFunction(planLicense.type)" class="license-item-value" width="30%">
                                        {{ getLicenseName(planLicense.type) }} <span v-if="isTrialOnPurchasedContract(planLicense.type)" v-t="'message.item_license_trial'"></span>
                                    </td>
                                    <td v-else class="license-item-value" width="30%">
                                        {{ getLicenseName(planLicense.type) }} <span v-if="isTrialOnPurchasedContract(planLicense.type)" v-t="'message.item_license_trial'"></span>
                                        <el-tooltip effect="dark" placement="top-start" >
                                            <div slot="content" style="text-align:left" v-html="$t('message.info_usage_license_zero')">
                                            </div>
                                            <img style="height:15px;vertical-align:middle" :src="require('@/assets/icon_caution.svg')"/>
                                        </el-tooltip>
                                    </td>
                                    <td class="license-item-value" width="20%" >{{ planLicense.currentValue }}</td>
                                    <td v-if="showPurchasedCount()" class="license-item-value" width="20%" >{{ planLicense.pastMax }}</td>
                                    <td v-if="showAvailableCount()" class="license-item-value" width="20%" >{{ getAvailableCount(planLicense) }}</td>
                                </tr>
                            </table>
                        </div>
                        <div v-if="offPlanLicenseContract.length !== 0">
                            <div class="license-title-box">
                                <div class="license-title-box-left" v-t="'message.item_license_off_plan'"></div>
                            </div>
                            <div class="license-table">
                                <table height=100% width=100% cellpadding=0 cellspacing=0>
                                    <tr v-if="appData.numberContract.length > 0" class="license-record-header">
                                        <td class="license-item-title" width="30%" v-t="'message.item_license_name'"></td>
                                        <td class="license-item-title" width="20%">
                                            {{ getDescriptionOfCurrent() }}
                                            <el-tooltip effect="dark" placement="right">
                                                <div slot="content" style="text-align:left">{{ getTooltipOfCurrent() }}</div>
                                                <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                            </el-tooltip>
                                        </td>
                                        <td v-if="showPurchasedCount()" class="license-item-title" width="20%">
                                            {{ getDescriptionOfPurchasedCount() }}
                                            <el-tooltip effect="dark" placement="right">
                                                <div slot="content" style="text-align:left">{{ getTooltipOfPurchasedCount() }}</div>
                                                <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                            </el-tooltip>
                                        </td>
                                        <td v-if="showAvailableCount()" class="license-item-title" width="20%">
                                            {{ getDescriptionOfAvailableCount() }}
                                            <el-tooltip effect="dark" placement="right">
                                                <div slot="content" style="text-align:left">{{ getTooltipOfAvailableCount() }}</div>
                                                <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                            </el-tooltip>
                                        </td>
                                    </tr>
                                    <tr v-for="(offPlanLicense,index) in offPlanLicenseContract" :class="{'license-record-no-hover': (index < offPlanLicenseContract.length - 1),'license-record-no-hover-bottom': (index === appData.numberContract.length - 1)}">
                                        <td v-if="isEnableFunction(offPlanLicense.type)" class="license-item-value" width="30%">
                                            {{ getLicenseName(offPlanLicense.type) }} <span v-if="isTrialOnPurchasedContract(offPlanLicense.type)" v-t="'message.item_license_trial'"></span>
                                        </td>
                                        <td v-else class="license-item-value" width="30%">
                                            {{ getLicenseName(offPlanLicense.type) }} <span v-if="isTrialOnPurchasedContract(offPlanLicense.type)" v-t="'message.item_license_trial'"></span>
                                            <el-tooltip effect="dark" placement="top-start" >
                                                <div slot="content" style="text-align:left" v-html="$t('message.info_usage_license_zero')">
                                                </div>
                                                <img style="height:15px;vertical-align:middle" :src="require('@/assets/icon_caution.svg')"/>
                                            </el-tooltip>
                                        </td>
                                        <td class="license-item-value" width="20%" >
                                            <span v-if="showCurrentValue(offPlanLicense)">{{ offPlanLicense.currentValue }}</span>
                                        </td>
                                        <td v-if="showPurchasedCount()" class="license-item-value" width="20%" >{{ offPlanLicense.pastMax }}</td>
                                        <td v-if="showAvailableCount()" class="license-item-value" width="20%" >{{ getAvailableCount(offPlanLicense) }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="license-title-box">
                            <div class="license-title-box-left" v-t="'message.item_license_recurring'"></div>
                        </div>
                        <div class="license-table">
                            <table height=100% width=100% cellpadding=0 cellspacing=0>
                                <tr v-if="appData.usageContract.length > 0" class="license-record-header">
                                    <td class="license-item-title" width="20%" v-t="'message.item_license_name'"></td>
                                    <td class="license-item-title" width="20%" v-t="'message.item_license_base_unit'"></td>
                                    <td class="license-item-title" width="20%" v-t="'message.item_license_recurring_volume'"></td>
                                    <td class="license-item-title" width="20%" v-t="'message.item_license_carry_over'"></td>
                                    <td class="license-item-title" width="20%" v-t="'message.item_license_available_volume'"></td>
                                </tr>
                                <tr v-else class="license-record-no-hover-top">
                                    <td class="license-item-value" v-t="'message.item_client_not_purchased'"></td>
                                </tr>
                                <tr v-for="(usageLicense,index) in appData.usageContract" :class="{'license-record-no-hover': (index<appData.usageContract.length-1),'license-record-no-hover-bottom': (index==appData.usageContract.length-1)}">
                                    <td class="license-item-value" width="20%">{{ getLicenseName(usageLicense.type) }}</td>
                                    <td class="license-item-value" width="20%">{{ Number(getBaseUsage(usageLicense)).toLocaleString() }} {{ getUnitName(usageLicense.type) }}</td>
                                    <td class="license-item-value" width="20%">{{ Number(getRecurring(usageLicense)).toLocaleString()}} {{ getUnitName(usageLicense.type) }}</td>
                                    <td class="license-item-value" width="20%">{{ Number(usageLicense.carryover1).toLocaleString() }} {{ getUnitNameForCurrent(usageLicense.type) }}</td>
                                    <td class="license-item-value" width="20%">{{ Number(usageLicense.currentValue).toLocaleString() }} {{ getUnitNameForCurrent(usageLicense.type) }}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="license-title-box">
                            <div class="license-title-box-left" v-t="'message.item_license_charge'"></div>
                        </div>
                        <div class="license-table">
                            <table height=100% width=100% cellpadding=0 cellspacing=0>
                                <tr v-if="appData.chargedList.length > 0" class="license-record-header">
                                    <td class="license-item-title" width="30%" v-t="'message.item_license_name'"></td>
                                    <td class="license-item-title" width="20%"></td>
                                    <td class="license-item-title" width="20%" v-t="'message.item_purchase_datetime'"></td>
                                    <td class="license-item-title" width="20%" v-t="'message.item_purchase_volume'"></td>
                                </tr>
                                <tr v-else class="license-record-no-hover-top">
                                    <td class="license-item-value" v-t="'message.item_client_not_purchased'"></td>
                                </tr>
                                <tr v-for="(chargedLicense,index) in appData.chargedList" :class="{'license-record-no-hover': (index<appData.chargedList.length-1),'license-record-no-hover-bottom': (index==appData.chargedList.length-1)}">
                                    <td class="license-item-value" width="30%">{{ getLicenseName(chargedLicense.type) }}</td>
                                    <td class="license-item-value" width="20%"></td>
                                    <td class="license-item-value" width="20%">{{ getDisplayDateTime(chargedLicense.isoPurchasedDatetime) }}</td>
                                    <td class="license-item-value" width="20%">{{ Number(getChargedVolume(chargedLicense.type , chargedLicense.quantity)).toLocaleString() }} {{ getUnitName(chargedLicense.type) }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div v-else>
                        <div class="license-table">
                            <!---- プラン売りライセンス ---->
                            <table height=100% width=100% cellpadding=0 cellspacing=0>
                                <tr v-if="appData.numberContract.length > 0" class="license-record-header">
                                    <!--- td class="license-item-title" width="30%">プラン名</td---->
                                    <td class="license-item-title" width="20%">
                                        {{ getDescriptionOfCurrent() }}
                                        <el-tooltip effect="dark" placement="right">
                                            <div slot="content" style="text-align:left">{{ getTooltipOfCurrent() }}</div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </td>
                                    <td v-if="showPurchasedCount()" class="license-item-title" width="20%">
                                        {{ getDescriptionOfPurchasedCount() }}
                                        <el-tooltip effect="dark" placement="right">
                                            <div slot="content" style="text-align:left">{{ getTooltipOfPurchasedCount() }}</div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </td>
                                    <td v-if="showAvailableCount()" class="license-item-title" width="20%">
                                        {{ getDescriptionOfAvailableCount() }}
                                        <el-tooltip effect="dark" placement="right">
                                            <div slot="content" style="text-align:left">{{ getTooltipOfAvailableCount() }}</div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </td>
                                    <td></td>
                                </tr>
                                <tr class="license-record-no-hover-bottom">
                                    <!----td class="license-item-value" width="30%">
                                        {{ getDisplayPlanName() }}
                                    </td---->
                                    <td class="license-item-value" width="30%" >{{ appData.numberContract[0].currentValue }}</td>
                                    <td v-if="showPurchasedCount()" class="license-item-value" width="30%" >{{ appData.numberContract[0].pastMax }}</td>
                                    <td v-if="showAvailableCount()" class="license-item-value" width="30%" >{{ getAvailableCount(appData.numberContract[0]) }}</td>
                                    <td style="text-align:right;padding-right:20px;padding-top:10px">
                                        <div v-if="appData.onlinePurchase && !isTrial() && (appData.basicContract.state !== Const.CONTRACT_TERMINATE)">
                                            <el-button v-if="!disableOnlinePayment" class="enable-command-button" style="width:250px" v-on:click="showPurchaseLicenseDialog()" v-t="'message.action_change_amount'"></el-button>
                                            <el-button v-else class="disable-command-button" style="width:250px" v-t="'message.action_change_amount'"></el-button>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                            <br>
                            <el-row :gutter="12">
                                <el-col :span="6">
                                    <el-card shadow="hover">
                                        <LicensePlanCard :basicContract="appData.basicContract" :planType="Const.LICENSE_PLAN_TALK_LITE" :alreadyPurchased="isAlreadyPurchased()" :registeredPlanChangeOperation="planChangeOperation" :existPendingProcess="disableOnlinePayment"
                                            :priceOfPlan="getPriceOfPlan(Const.LICENSE_PLAN_TALK_LITE)" :currencyYen="currencyYen"
                                            @showDetail="showPlanDescriptionDialog(Const.LICENSE_PLAN_TALK_LITE)" @purchasePlan="showPurchasePlanDialog" @cancelDowngrade="cancelDowngrade"/>
                                    </el-card>
                                </el-col>
                                <el-col :span="6">
                                    <el-card shadow="hover">
                                        <LicensePlanCard :basicContract="appData.basicContract" :planType="Const.LICENSE_PLAN_TALK_ENT" :alreadyPurchased="isAlreadyPurchased()" :registeredPlanChangeOperation="planChangeOperation" :existPendingProcess="disableOnlinePayment"
                                         :priceOfPlan="getPriceOfPlan(Const.LICENSE_PLAN_TALK_ENT)" :currencyYen="currencyYen"
                                         @showDetail="showPlanDescriptionDialog(Const.LICENSE_PLAN_TALK_ENT)" @purchasePlan="showPurchasePlanDialog" @cancelDowngrade="cancelDowngrade"/>
                                    </el-card>
                                </el-col>
                                <el-col v-if="appData.basicContract.planType == Const.LICENSE_PLAN_LIVE_LITE" :span="6">
                                    <el-card shadow="hover">
                                        <LicensePlanCard :basicContract="appData.basicContract" :planType="Const.LICENSE_PLAN_LIVE_LITE" :alreadyPurchased="isAlreadyPurchased()" :registeredPlanChangeOperation="planChangeOperation" :existPendingProcess="disableOnlinePayment"
                                         :priceOfPlan="getPriceOfPlan(Const.LICENSE_PLAN_LIVE_LITE)" :currencyYen="currencyYen"
                                         @showDetail="showPlanDescriptionDialog(Const.LICENSE_PLAN_LIVE_LITE)" @purchasePlan="showPurchasePlanDialog" @cancelDowngrade="cancelDowngrade"/>
                                    </el-card>
                                </el-col>
                                <el-col :span="6">
                                    <el-card shadow="hover">
                                        <LicensePlanCard :basicContract="appData.basicContract" :planType="Const.LICENSE_PLAN_LIVE_ENT" :alreadyPurchased="isAlreadyPurchased()" :registeredPlanChangeOperation="planChangeOperation" :existPendingProcess="disableOnlinePayment"
                                         :priceOfPlan="getPriceOfPlan(Const.LICENSE_PLAN_LIVE_ENT)" :currencyYen="currencyYen"
                                         @showDetail="showPlanDescriptionDialog(Const.LICENSE_PLAN_LIVE_ENT)" @purchasePlan="showPurchasePlanDialog" @cancelDowngrade="cancelDowngrade"/>
                                    </el-card>
                                </el-col>
                            </el-row>
                            <br>
                        </div>
                        <div v-if="offPlanLicenseContract.length !== 0">
                            <div class="license-title-box">
                                <div class="license-title-box-left" v-t="'message.item_license_off_plan'"></div>
                            </div>
                            <div class="license-table">
                                <table height=100% width=100% cellpadding=0 cellspacing=0>
                                    <tr v-if="appData.numberContract.length > 0" class="license-record-header">
                                        <td class="license-item-title" width="30%" v-t="'message.item_license_name'"></td>
                                        <td class="license-item-title" width="20%">
                                            {{ getDescriptionOfCurrent() }}
                                            <el-tooltip effect="dark" placement="right">
                                                <div slot="content" style="text-align:left">{{ getTooltipOfCurrent() }}</div>
                                                <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                            </el-tooltip>
                                        </td>
                                        <td v-if="showPurchasedCount()" class="license-item-title" width="20%">
                                            {{ getDescriptionOfPurchasedCount() }}
                                            <el-tooltip effect="dark" placement="right">
                                                <div slot="content" style="text-align:left">{{ getTooltipOfPurchasedCount() }}</div>
                                                <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                            </el-tooltip>
                                        </td>
                                        <td v-if="showAvailableCount()" class="license-item-title" width="20%">
                                            {{ getDescriptionOfAvailableCount() }}
                                            <el-tooltip effect="dark" placement="right">
                                                <div slot="content" style="text-align:left">{{ getTooltipOfAvailableCount() }}</div>
                                                <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                            </el-tooltip>
                                        </td>
                                    </tr>
                                    <tr v-for="(offPlanLicense,index) in offPlanLicenseContract" :class="{'license-record-no-hover': (index < offPlanLicenseContract.length - 1),'license-record-no-hover-bottom': (index === appData.numberContract.length - 1)}">
                                        <td v-if="isEnableFunction(offPlanLicense.type)" class="license-item-value" width="30%">
                                            {{ getLicenseName(offPlanLicense.type) }} <span v-if="isTrialOnPurchasedContract(offPlanLicense.type)" v-t="'message.item_license_trial'"></span>
                                        </td>
                                        <td v-else class="license-item-value" width="30%">
                                            {{ getLicenseName(offPlanLicense.type) }} <span v-if="isTrialOnPurchasedContract(offPlanLicense.type)" v-t="'message.item_license_trial'"></span>
                                            <el-tooltip effect="dark" placement="top-start" >
                                                <div slot="content" style="text-align:left" v-html="$t('message.info_usage_license_zero')">
                                                </div>
                                                <img style="height:15px;vertical-align:middle" :src="require('@/assets/icon_caution.svg')"/>
                                            </el-tooltip>
                                        </td>
                                        <td class="license-item-value" width="20%" >
                                            <span v-if="showCurrentValue(offPlanLicense)">{{ offPlanLicense.currentValue }}</span>
                                        </td>
                                        <td v-if="showPurchasedCount()" class="license-item-value" width="20%" >{{ offPlanLicense.pastMax }}</td>
                                        <td v-if="showAvailableCount()" class="license-item-value" width="20%" >{{ getAvailableCount(offPlanLicense) }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </tr>
        </table>
        <purchasenewlicense v-if="showPurchaseNewLicense" :appData="appData" :primaryOwner="primaryOwner" :licenseInfo="licenseUpdateParam" :contractInfo="appData.basicContract" :disablePurchasingOption="disablePurchasingOption" @save="purchaseLicenseNew" :currencyYen="currencyYen" :purchasePlanType="selectedPlanType" :priceList="priceList" :paidMemberStatus="paidMemberStatus" @edituser="moveToGroupAndUser()" @cancel="showPurchaseNewLicense=false"></purchasenewlicense>
        <purchaselicense v-if="showPurchaseLicense" :appData="appData" :licenseInfo="licenseUpdateParam" :contractInfo="appData.basicContract" :contractChangeOperation="contractChangeOperation" :disablePurchasingOption="disablePurchasingOption" :priceList="priceList" @save="purchaseLicenseChange" :currencyYen="currencyYen" @edituser="moveToGroupAndUser()" @cancel="showPurchaseLicense=false"></purchaselicense>
        <ConfirmGeneral v-if="showConfirmGeneral" :confirmInfo="generalConfirmInfo" @agree="confirmAgree()" @cancel="showConfirmGeneral=false"></ConfirmGeneral>
        <confirmchangecontracttype v-if="showConfirmChangeContractType" :appData="appData" :priceList="priceList" :basicContract="appData.basicContract" :licenseInfo="licenseUpdateParam" :contractChangeOperation="contractChangeOperation" :disablePurchasingOption="disablePurchasingOption" :currencyYen="currencyYen" @agree="handleRegisterContractChange()" @cancel="showConfirmChangeContractType=false"></confirmchangecontracttype>
        <ConfirmChangePlanType v-if="showConfirmChangePlanType" :priceList="priceList" :appData="appData" :changePlanType="selectedPlanType" :currencyYen="currencyYen" @agree="handleChangePlanType" @cancel="showConfirmChangePlanType=false"></ConfirmChangePlanType>
        <LicensePlanDescription v-if="showLicensePlanDescription" :selectedPlanType="selectedPlanType" :purchasePlanType="appData.basicContract.planType" @close="showLicensePlanDescription=false"></LicensePlanDescription>
    </div>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import PurchaseLicense from "./PurchaseLicense.vue"
import PurchaseNewLicense from "./PurchaseNewLicense.vue"
import commonUtil from './commonutil.js';
import constants from './constants.js';
import ConfirmGeneral from './ConfirmGeneral.vue';
import ConfirmChangeContractType from './ConfirmChangeContractType.vue';
import ConfirmChangePlanType from './ConfirmChangePlanType.vue';
import LicensePlanCard from './LicensePlanCard.vue';
import LicensePlanDescription from './LicensePlanDescription.vue';

export default {
    data () {
        return {
            pendingOnline: false,
            pendingClosing: false,
            pendingPaidReview: false,
            paidDisable: false,
            disableOnlinePayment: false,
            managementUserRights: false,
            pendingTransactionList: null,
            pendingPaymentMethod: 0,
            primaryOwner: null,
            priceList: [],
            contractChangeOperation: null,
            planChangeOperation: null,
            contractChangeRequestCode: 0,
            showPurchaseNewLicense: false,
            showPurchaseLicense: false,
            showConfirmGeneral: false,
            showConfirmChangeContractType: false,
            showConfirmChangePlanType: false,
            showLicensePlanDescription: false,
            basicContract: null,
            localNextFlushDate: null,
            currentContractStatus: 0,
            purchaseStartDatetime: null,
            licenseUpdateParam: {
                numberLicense: [],
                usageLicense: [],
                chargedLicense: [],
            },
            generalConfirmInfo: {
                title: null,
                description: null
            },
            purchasePlanType: 0,
            Const: {
                CONTRACT_TERMINATE: constants.CONTRACT_TERMINATE,
                LICENSE_PLAN_TALK_LITE: constants.LICENSE_PLAN_TALK_LITE,
                LICENSE_PLAN_TALK_ENT: constants.LICENSE_PLAN_TALK_ENT,
                LICENSE_PLAN_LIVE_LITE: constants.LICENSE_PLAN_LIVE_LITE,
                LICENSE_PLAN_LIVE_ENT: constants.LICENSE_PLAN_LIVE_ENT,
                PLAN_CHANGE_TO_TL: 1,
                PLAN_CHANGE_TO_TE: 2,
                PLAN_CHANGE_TO_LL: 3,
                PLAN_CHANGE_TO_LE: 4,
            },
            selectedPlanType: 0,
            paidMemberStatus: null,
        };
    },
    methods: {
        handlePurchaseLicense(purchasePlanType) {
            this.purchasePlanType = purchasePlanType;
            this.checkCreditCardInfo();
        },
        handlePurchasePlanChange(newPlanType) {
            let planUpgrade = false;
            switch(newPlanType) {
                case Const.PLAN_CHANGE_TO_TL:
                    this.purchasePlanType = purchasePlanType;
                    break;
                case Const.PLAN_CHANGE_TO_TE:
                    if (this.appData.basicContract.planType == constants.LICENSE_PLAN_TALK_LITE) {
                        planUpgrade = true;
                        this.purchasePlanType = constants.PLAN_UPGRADE_TL_TE;
                    }
                    break;
                case Const.PLAN_CHANGE_TO_LL:
                    if (this.appData.basicContract.planType == constants.LICENSE_PLAN_TALK_LITE) {
                        planUpgrade = true;
                        this.purchasePlanType = constants.PLAN_UPGRADE_TL_LL;
                    }
                    break;
                case Const.PLAN_CHANGE_TO_LE:
                    switch(this.appData.basicContract.planType) {
                        case constants.LICENSE_PLAN_TALK_LITE:
                            planUpgrade = true;
                            this.purchasePlanType = constants.PLAN_UPGRADE_TL_LE;
                            break;
                        case constants.LICENSE_PLAN_TALK_ENT:
                            planUpgrade = true;
                            this.purchasePlanType = constants.PLAN_UPGRADE_TE_LE;
                            break;
                        case constants.LICENSE_PLAN_LIVE_LITE:
                            planUpgrade = true;
                            this.purchasePlanType = constants.PLAN_UPGRADE_LL_LE;
                            break;
                    }
                    break;
            }
            this.checkCreditCardInfo();
        },
        handleRegisterContractChange() {
            this.showConfirmChangeContractType = false;
            let self = this;
            if (this.contractChangeOperation == null) {
                let deferredOperationList = [];
                deferredOperationList.push({ operationDatetime: this.appData.basicContract.nextFlushDatetime, operationCode: this.contractChangeRequestCode });
                server.post('/createdeferredprocessinfo', { tenantId: this.appData.tenantList[0].tenantId, deferredOperationRequestList: deferredOperationList })
                    .then((res) => {
                        if (res.data.status == constants.STATUS_SUCCESS) {
                            commonUtil.notifyMessage(self,"Success",self.getContractChangeNotice());
                            self.getContractChangeOperation(self.appData.tenantList[0].tenantId);
                        } else {
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleRegisterContractChange-2").replace("{code}",res.data.status));
                        }
                    })
                    .catch( function ( error ) {
                        commonUtil.putExceptionErrorMessage(self, "handleRegisterContractChange-2", error);
                    });
            } else {
                // delete deferredProcessInfo
                server.post('/deletedeferredprocessinfo', { tenantId: this.appData.tenantList[0].tenantId, requestId: this.contractChangeOperation.requestId })
                    .then((res) => {
                        if (res.data.status == constants.STATUS_SUCCESS) {
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_cancel_change_contract_at_renewal"));
                            self.getContractChangeOperation(self.appData.tenantList[0].tenantId);
                        } else {
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleRegisterContractChange-1").replace("{code}",res.data.status));
                        }
                    })
                    .catch( function ( error ) {
                        commonUtil.putExceptionErrorMessage(self, "handleRegisterContractChange-1", error);
                    });
            }
        },
        handleChangePlanType(upgradeType) {
            this.showConfirmChangePlanType = false;
            let self = this;
            if (upgradeType < 0) {
                // downgrade the plan
                this.planChangeOperation = null;
                let deferredOperationList = [];
                deferredOperationList.push({ operationDatetime: this.appData.basicContract.nextFlushDatetime, operationCode: commonUtil.getDowngradeDeferredRequestCode(this.appData.basicContract.planType, this.selectedPlanType) });
                server.post('/createdeferredprocessinfo', { tenantId: this.appData.tenantList[0].tenantId, deferredOperationRequestList: deferredOperationList })
                    .then((res) => {
                        if (res.data.status == constants.STATUS_SUCCESS) {
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_downgrade_registered"));
                            this.getContractChangeOperation(self.appData.tenantList[0].tenantId);
                        } else {
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleChangePlanType").replace("{code}",res.data.status));
                        }
                    })
                    .catch( function ( error ) {
                        commonUtil.putExceptionErrorMessage(self, "handleChangePlanType", error);
                    });
            } else {
                // upgrade the plan
                const loadingScreen = this.$loading({
                        lock: true ,
                        text: 'Confirming registered Credit Card ...' ,
                        spinner: 'el-icon-loading' ,
                        background: 'rgba(0, 0, 0, 0.7)'
                });

                let self = this;
                this.showPurchaseLicense = false;
                let totalAmount = 0;

                let numberLicenseUpdateParam = [];
                numberLicenseUpdateParam.push({type: constants.LICENSE_USER , totalQuantity: this.appData.numberContract[0].pastMax, addQuantity: 0, originalQuantity: this.appData.numberContract[0].currentMax});

                let purchaseLicenseParam = {
                        orderInfo: {
                            tenantId: this.appData.tenantList[0].tenantId ,
                            requestType: constants.PURCHASE_REQUEST_CHANGE_PLAN,
                            purchasePeriodType: this.appData.basicContract.purchasePeriodType ,
                            purchasePlanType: this.selectedPlanType
                        },
                        number: numberLicenseUpdateParam ,
                }
                this.purchaseLicense(purchaseLicenseParam,loadingScreen);

            }
        },
        getPendingOnlineAlertMessage() {
            if (this.pendingPaymentMethod === constants.BILLING_CREDIT_CARD) {
                return commonUtil.getMessageText(this.$i18n, "info_not_confirm_settlement");
            } else {
                return commonUtil.getMessageText(this.$i18n, "info_not_confirm_settlement_paid");
            }
        },
        getPriceInfo() {
            let self = this;
            server.post('/getpriceinfo')
                .then((res) => {
                    if (res.data.status == constants.STATUS_SUCCESS) {
                        self.priceList = res.data.priceInfo;
                    } else {
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getTenantInfo-2").replace("{code}",res.data.status));
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getTenantInfo", error);
                });
        },
        getContractChangeOperation(tenantId) {
            let self = this;
            this.contractChangeOperation = null;
            this.planChangeOperation = null;
            server.post('/getdeferredprocessinfo', {tenantId: tenantId })
                .then((res) => {
                    if (res.data.status == constants.STATUS_SUCCESS) {
                        self.deferredProcessInfoList = res.data.deferredProcessInfoList;
                        for (let deferredProcessInfo of res.data.deferredProcessInfoList) {
                            switch(deferredProcessInfo.operationCode) {
                                case constants.DEFERRED_MONTH_TO_YEAR:
                                case constants.DEFERRED_YEAR_TO_MONTH:
                                    self.contractChangeOperation = deferredProcessInfo;
                                    break;
                                case constants.DEFERRED_TE_TO_TL:
                                case constants.DEFERRED_TE_TO_LL:
                                case constants.DEFERRED_LL_TO_TL:
                                case constants.DEFERRED_LL_TO_TE:
                                case constants.DEFERRED_LE_TO_TL:
                                case constants.DEFERRED_LE_TO_LL:
                                case constants.DEFERRED_LE_TO_TE:
                                    self.planChangeOperation = deferredProcessInfo;
                                    break;
                            }
                        }
                        if (self.contractChangeOperation == null) {
                            if (this.appData.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                                self.contractChangeRequestCode = constants.DEFERRED_MONTH_TO_YEAR;
                            } else {
                                self.contractChangeRequestCode = constants.DEFERRED_YEAR_TO_MONTH;;
                            }
                        } else {
                            self.contractChangeRequestCode = 0;
                        }
                    } else {
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getTenantInfo-3").replace("{code}",res.data.status));
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getTenantInfo-3", error);
                });
        },
        getUserRights() {
            let self = this;
            let loginId =  this.appData.loginId.split("@");
            server.post('/getinfo',{tenantId: this.appData.tenantList[0].tenantId, name: loginId[0], type: 1, userTalkgroupInfo: false }
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        self.managementUserRights = commonUtil.checkUserPrivilege(res.data.rights, constants.PRIVILEGE_TENANT_ADMIN);
                        break;
                    case constants.STATUS_ERROR_DENIED:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_confirm_rights_by_denied"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getUserRights").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "getUserRights", error);
            });
        },
        checkCreditCardInfo() {
            let self = this;
            server.post('/gmopaymentsearchcard'
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        let currentDate = new Date();
                        let cardExpired = false;
                        if (res.data.expireYear < (currentDate.getFullYear() - 2000)) {
                            cardExpired = true;
                        }
                        if (res.data.expireYear == (currentDate.getFullYear() - 2000)) {
                            if (res.data.expireMonth < (currentDate.getMonth() + 1)) {
                                cardExpired = true;
                            }
                        }
                        if (cardExpired) {
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_creditCard_expired"));
                        } else {
                            self.showPurchaseLicenseDialog();
                        }
                        break;
                    case constants.STATUS_ERROR_EXTERNAL_SYSTEM:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_creditCard_not_found"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","checkCreditCardInfo").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "checkCreditCardInfo", error);
            });
        },
        checkPaidMemberStatus() {
            switch(this.appData.basicContract.billingType) {
                case constants.BILLING_PAID:
                case constants.BILLING_UNDEFINED:
                    break;
                case constants.BILLING_CREDIT_CARD:
                    if ((this.appData.basicContract.state === constants.CONTRACT_TERMINATE) || (this.appData.basicContract.state === constants.CONTRACT_DISABLED)) {
                        // need to check the status of PAID when contract is not active which was purchased by credit card.
                    } else {
                        return;                 // do not need to check the status of PAID when active contract was purchased by credit card.
                    }
                    break;
                default:
                    return;                     // do not need to check the status of PAID when billing paper.
            }

            let self = this;
            server.post('/getpaidmemberstatus'
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        self.paidMemberStatus = res.data.memberStatus;
                        switch(self.paidMemberStatus) {
                            case constants.PAID_STATUS_ENABLE_IN_USE:
                            case constants.PAID_STATUS_REVIEWING:
                                self.paidDisable = false;
                                break;
                            default:
                                self.paidDisable = true;
                                break;
                        }
                        break;
                    case constants.STATUS_ERROR_NOT_FOUND:
                        self.paidMemberStatus = constants.PAID_STATUS_NOT_FOUND;
                        if (this.appData.basicContract.billingType === constants.BILLING_PAID) {
                            self.paidDisable = true;
                        } else {
                            self.paidDisable = false;
                        }
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","checkPaidMemberStatus").replace("{code}",res.data.status));
                        break;
                }
                self.setDisabledOnlinePaymentStatus();
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "checkPaidMemberStatus", error);
            });
        },
        showPurchaseLicenseDialog() {
            if (this.appData.basicContract.billingType === constants.BILLING_PAID) {
                if (this.paidMemberStatus !== constants.PAID_STATUS_ENABLE_IN_USE) {
                    commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_cannot_change_license_paid_not_enabled"));
                    return;
                }
            }
            this.purchaseStartDatetime = new Date();
            this.createLicenseUpdateParam();
            if (this.isAlreadyPurchased()) {
                this.showPurchaseLicense=true;
            } else {
                this.showPurchaseNewLicense=true;
            }
        },
        showConfirmAutoUpdateDialog() {
            if (this.managementUserRights) {
                if (this.planChangeOperation != null) {
                    commonUtil.notifyMessage(this,"Warning","プランのダウングレードが予約されているので、自動更新を終了できません。");
                    return;
                }
                if (this.appData.basicContract.state == constants.CONTRACT_ACTIVE) {
                    this.generalConfirmInfo.title = commonUtil.getMessageText(this.$i18n,"title_stop_auto_update");
                    this.generalConfirmInfo.description = commonUtil.getMessageText(this.$i18n,"info_stop_auto_update").replace('{nextFlushDate}', this.getDisplayExpireDateTime(this.appData.basicContract.purchasePeriodType));
                } else {
                    this.generalConfirmInfo.title = commonUtil.getMessageText(this.$i18n,"title_start_auto_update");
                    this.generalConfirmInfo.description = commonUtil.getMessageText(this.$i18n,"info_start_auto_update").replace('{nextFlushDate}', this.getDisplayExpireDateTime(this.appData.basicContract.purchasePeriodType));
                }
                this.showConfirmGeneral = true;
            } else {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_change_autoRenewal"));
            }
        },
        showConfirmChangeContractTypeDialog() {
            this.createLicenseUpdateParam();
            this.showConfirmChangeContractType = true;
        },
        showPurchasePlanDialog(planType) {
            if ((this.appData.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_TRIAL) || (this.appData.basicContract.state == constants.CONTRACT_TERMINATE)) {
                this.selectedPlanType = planType;
                this.licenseUpdateParam.numberLicense = [];
                let userLicense = this.appData.numberContract[0];
                this.licenseUpdateParam.numberLicense.push({
                            type: userLicense.value ,
                            pastMax: userLicense.pastMax,
                            orgValue: userLicense.currentMax,
                            newValue: userLicense.currentMax,
                            current: userLicense.currentValue,
                            disabled: false,
                            displayName: commonUtil.getPlanName(this.purchasePlanType),
                            monthlyPrice: this.getUnitPrice(planType, "month"),
                            yearlyPrice: this.getUnitPrice(planType,"year")
                });
                this.showPurchaseNewLicense = true;
            } else {
                if (this.appData.basicContract.billingType === constants.BILLING_PAID) {
                    if (this.paidMemberStatus !== constants.PAID_STATUS_ENABLE_IN_USE) {
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_cannot_change_license_paid_not_enabled"));
                        return;
                    }
                }
                this.selectedPlanType = planType;
                this.showConfirmChangePlanType = true;
            }
        },
        cancelDowngrade(downgradeOperation) {
            // delete deferredProcessInfo
            let self = this;
            server.post('/deletedeferredprocessinfo', { tenantId: downgradeOperation.tenantId, requestId: downgradeOperation.requestId })
            .then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_downgrade_canceled"));
                    self.getContractChangeOperation(self.appData.tenantList[0].tenantId);
                } else {
                    commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","cancelDowngrade").replace("{code}",res.data.status));
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "cancelDowngrade", error);
            });
        },
        createLicenseUpdateParam() {
            let licenseParam;
            this.licenseUpdateParam.numberLicense = [];
            this.licenseUpdateParam.usageLicense = [];
            this.licenseUpdateParam.chargedLicense = [];
            let licenseList = commonUtil.getLicenseListForEndUser(this.$i18n);

            let numberSpeechDisabled = true;
            let numberTranslationDisabled = true;

            for (let license of commonUtil.getLicenseListForEndUser(this.$i18n)) {
                if (license.value < 100) {
                    licenseParam = null;
                    for (let numberLicense of this.appData.numberContract) {
                        if (numberLicense.type == license.value) {
                            licenseParam = {
                                    type: license.value ,
                                    pastMax: numberLicense.pastMax,
                                    orgValue: numberLicense.currentMax,
                                    newValue: numberLicense.currentMax,
                                    current: numberLicense.currentValue,
                                    disabled: false,
                                    displayName: license.displayName,
                                    monthlyPrice: this.getUnitPrice(license.value,"month"),
                                    yearlyPrice: this.getUnitPrice(license.value,"year")
                            };
                            switch(license.value) {
                                case constants.LICENSE_SPEECH_TEXT:
                                    numberSpeechDisabled = false;
                                    break;
                                case constants.LICENSE_TRANSLATION:
                                    numberTranslationDisabled = false;
                                    break;
                            }
                            break;
                        }
                    }
                    if (licenseParam == null) {
                        licenseParam = {
                                    type: license.value ,
                                    pastMax: 0 ,
                                    orgValue: 0 ,
                                    newValue: 0,
                                    newCount: 0,
                                    current: 0,
                                    disabled: false,
                                    displayName: license.displayName,
                                    monthlyPrice: this.getUnitPrice(license.value,"month"),
                                    yearlyPrice: this.getUnitPrice(license.value,"year")
                        };
                    }
                    this.licenseUpdateParam.numberLicense.push(licenseParam)
                }
                if ((license.value == constants.RECURRING_SPEECH_TEXT) || (license.value == constants.RECURRING_TRANSLATION)) {
                    licenseParam = null;
                    for (let usageLicense of this.appData.usageContract) {
                        if (usageLicense.type == license.value) {
                            let purchasedRecurringItem = this.appData.purchasedRecurringList.filter(function(item, index){
                                if (item.type == license.value) return true;
                            });
                            let purchasedRecurringValue;
                            if (purchasedRecurringItem.length == 0) {
                                purchasedRecurringValue = 0;
                            } else {
                                purchasedRecurringValue = purchasedRecurringItem[0].quantity * this.getLicenseUnit(license.value);
                            }
                            licenseParam = {
                                    type: license.value ,
                                    current: purchasedRecurringValue,
                                    orgValue: usageLicense.recurring,
                                    newValue: usageLicense.recurring,
                                    newCount: usageLicense.recurring / this.getLicenseUnit(license.value) ,
                                    unit: this.getLicenseUnit(license.value),
                                    disabled: false ,
                                    displayName: this.getLicenseName(license.value),
                                    chargePrice: this.getUnitPrice(license.value,"charge")
                            };
                            break;
                        }
                    }
                    if (licenseParam == null) {
                        let disabled;
                        switch(license.value) {
                            case constants.RECURRING_SPEECH_TEXT:
                                disabled = numberSpeechDisabled;
                                break;
                            case constants.RECURRING_TRANSLATION:
                                disabled = numberTranslationDisabled;
                                break;
                        }
                        licenseParam = {
                                type: license.value ,
                                current: 0 ,
                                orgValue: 0 ,
                                newValue: 0,
                                newCount: 0,
                                unit: this.getLicenseUnit(license.value),
                                disabled: disabled ,
                                displayName: this.getLicenseName(license.value),
                                chargePrice: this.getUnitPrice(license.value,"charge")
                        };
                    }
                    this.licenseUpdateParam.usageLicense.push(licenseParam)
                }

                if ((license.value == constants.CHARGE_SPEECH_TEXT) || (license.value == constants.CHARGE_TRANSLATION)) {
                    let disabled;
                    switch(license.value) {
                        case constants.CHARGE_SPEECH_TEXT:
                            disabled = numberSpeechDisabled;
                            break;
                        case constants.CHARGE_TRANSLATION:
                            disabled = numberTranslationDisabled;
                            break;
                    }
                    let existChargedValue = 0;
                    for (let chargedLicense of this.appData.chargedList) {
                        if (chargedLicense.type == license.value) {
                            existChargedValue += this.getChargedVolume(chargedLicense.type , chargedLicense.quantity);
                        }
                    }
                    licenseParam = {type: license.value , orgValue: existChargedValue , newValue: 0, newCount: 0, unit: this.getLicenseUnit(license.value), disabled: disabled ,displayName: this.getLicenseName(license.value),chargePrice: this.getUnitPrice(license.value,"charge")};
                    this.licenseUpdateParam.chargedLicense.push(licenseParam)
                }
            }
        },
        /*
        registerUserToGMOPayment() {
            let self = this;
            server.post('/gmopaymentsavemember'
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_creditCard_registered"));
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_EXTERNAL_SYSTEM:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_other_system").replace("{functionName}","registerUserToGMOPayment").replace("{code}",res.data.errorInfo));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","registerUserToGMOPayment").replace("{code}",res.data.status));
                            break;
                    }
                    return;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "registerUserToGMOPayment", error);
            });
        },
        */
        purchaseLicenseNew(input) {
            const loadingScreen = this.$loading({
                    lock: true ,
                    text: 'Processing the your payment ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0.7)'
            });

            let self = this;
            this.showPurchaseNewLicense = false;
            let totalAmount = 0;

            let numberLicenseUpdateParam = [];
            let usageLicenseUpdateParam = [];
            let chargedLicenseUpdateParam = [];
            let purchaseLicenseParam = {};
            let orderInfo = {
                            tenantId: this.appData.tenantList[0].tenantId ,
                            requestType: input.requestType,
                            purchasePeriodType: input.purchasePeriodType,
                            purchasePlanType: this.selectedPlanType
                        };
            let paidInformation = null;
            if ((Number(input.billingType) === constants.BILLING_PAID) && (input.paidInformation !== null)) {
                paidInformation = {
                    companyName: input.paidInformation.companyName.value,
                    companyNameKana: input.paidInformation.companyNameKana.value,
                    representativeSei: input.paidInformation.representativeLastName.value,
                    representativeMei: input.paidInformation.representativeFirstName.value,
                    representativeSeiKana: input.paidInformation.representativeLastNameKana.value,
                    representativeMeiKana: input.paidInformation.representativeFirstNameKana.value,
                    zipCode: input.paidInformation.zip.value.substring(0,3) + "-" + input.paidInformation.zip.value.substring(3),
                    prefecture: input.paidInformation.pref.value,
                    address1: input.paidInformation.city.value,
                    address2: input.paidInformation.town.value,
                    address3: input.paidInformation.street.value,
                    auxName: input.paidInformation.departmentName.value,
                    clerkSei: input.paidInformation.clerkLastName.value,
                    clerkMei: input.paidInformation.clerkFirstName.value,
                    clerkSeiKana: input.paidInformation.clerkLastNameKana.value,
                    clerkMeiKana: input.paidInformation.clerkFirstNameKana.value,
                    tel: input.paidInformation.phoneNumber1.value + "-" + input.paidInformation.phoneNumber2.value + "-" + input.paidInformation.phoneNumber3.value,
                    employees: input.paidInformation.employees.value,
                    email: input.paidInformation.email.value
                }
            }

            if (input.requestType == constants.PURCHASE_REQUEST_NEW) {
                for (let numberLicense of input.license.numberLicense) {
                    if (numberLicense.newValue > 0) {
                        if (Number(input.purchasePeriodType) == constants.PURCHASE_PERIOD_MONTHLY) {
                            numberLicenseUpdateParam.push({type: numberLicense.type , totalQuantity: numberLicense.newValue, addQuantity: numberLicense.newValue, originalQuantity: 0 });
                            totalAmount += numberLicense.purchaseMonthlyAmount;
                        } else {
                            numberLicenseUpdateParam.push({type: numberLicense.type , totalQuantity: numberLicense.newValue, addQuantity: numberLicense.newValue, originalQuantity: 0 });
                            totalAmount += numberLicense.purchaseYearlyAmount;
                        }
                    }
                }

                for (let usageLicense of input.license.usageLicense) {
                    if (usageLicense.newValue > 0) {
                        if (Number(input.purchasePeriodType) == constants.PURCHASE_PERIOD_MONTHLY) {
                            usageLicenseUpdateParam.push({type: usageLicense.type , totalQuantity: usageLicense.newValue , addQuantity: usageLicense.newValue});
                            totalAmount += usageLicense.purchaseMonthlyAmount;
                        } else {
                            usageLicenseUpdateParam.push({type: usageLicense.type , totalQuantity: usageLicense.newValue , addQuantity: usageLicense.newValue});
                            totalAmount += usageLicense.purchaseYearlyAmount;
                        }
                    }
                }
            } else {
                let numberLicense = input.license.numberLicense[0];
                let purchasePeriodType;
                let totalAmount;
                if (input.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                    purchasePeriodType = "month";
                    totalAmount = numberLicense.newValue * this.getUnitPrice(this.selectedPlanType, purchasePeriodType);
                } else {
                    purchasePeriodType = "year";
                    totalAmount = numberLicense.newValue * this.getUnitPrice(this.selectedPlanType, purchasePeriodType) * 12;
                }
                let purchaseProductInfo = commonUtil.getPlanName(this.selectedPlanType) + ";" + purchasePeriodType + ";" + numberLicense.newValue + ";" + totalAmount;
                window.dataLayer.push({
                                       event: 'FireVirtualPV',
                                       category: "License",
                                       "content-name": window.location.pathname,
                                       "content-view-name": "license_purchase_complete",
                                       "license-plan": commonUtil.getPlanName(this.selectedPlanType),
                                       "license-purchase-productinfo": purchaseProductInfo,
                                       "tenant-name": this.appData.tenantList[0].name
                                   });
                numberLicenseUpdateParam.push({type: constants.LICENSE_USER, totalQuantity: numberLicense.newValue, addQuantity: numberLicense.newValue, originalQuantity: 0 });
            }

            purchaseLicenseParam = {
                   billingType: Number(input.billingType) ,
                   paidMemberData: paidInformation,
                   orderInfo: orderInfo,
                   number: numberLicenseUpdateParam ,
                   recurring: usageLicenseUpdateParam ,
                   charge: chargedLicenseUpdateParam
            }

            this.purchaseLicense(purchaseLicenseParam,loadingScreen);
        },
        purchaseLicenseChange(input) {
            const loadingScreen = this.$loading({
                    lock: true ,
                    text: 'Processing the your payment ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0.7)'
            });

            let self = this;
            this.showPurchaseLicense = false;
            let totalAmount = 0;

            let numberLicenseUpdateParam = [];
            let usageLicenseUpdateParam = [];
            let chargedLicenseUpdateParam = [];
            let orderInfo = {
                tenantId: this.appData.tenantList[0].tenantId ,
                requestType: input.requestType,
                purchasePeriodType: this.appData.basicContract.purchasePeriodType ,
                purchasePlanType: this.appData.basicContract.planType ,
                totalAmount: totalAmount
            };

            if (input.requestType == constants.PURCHASE_REQUEST_MODIFY) {
                for (let numberLicense of input.license.numberLicense) {
                    let addQuantity;
                    if (numberLicense.newValue > numberLicense.orgValue) {
                        addQuantity = numberLicense.newValue - numberLicense.orgValue;
                    } else {
                        addQuantity = 0;
                    }
                    if (numberLicense.orgValue != numberLicense.newValue) {
                        if (Number(this.appData.basicContract.purchasePeriodType) == constants.PURCHASE_PERIOD_MONTHLY) {
                            numberLicenseUpdateParam.push({type: numberLicense.type , totalQuantity: numberLicense.newValue, addQuantity: addQuantity, originalQuantity: numberLicense.orgValue});
                        } else {
                            numberLicenseUpdateParam.push({type: numberLicense.type , totalQuantity: numberLicense.newValue, addQuantity: addQuantity, originalQuantity: numberLicense.orgValue});
                        }
                        totalAmount += numberLicense.purchaseAmount;
                    }
                }

                for (let usageLicense of input.license.usageLicense) {
                    if (usageLicense.orgValue != usageLicense.newValue) {
                        if (usageLicense.newValue > usageLicense.orgValue) {
                            usageLicenseUpdateParam.push({type: usageLicense.type , totalQuantity: usageLicense.newValue , addQuantity: (usageLicense.newValue - usageLicense.orgValue), originalQuantity: usageLicense.orgValue});
                        } else {
                            usageLicenseUpdateParam.push({type: usageLicense.type , totalQuantity: usageLicense.newValue , addQuantity: 0, originalQuantity: usageLicense.orgValue});
                        }
                        if (this.appData.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                            totalAmount += usageLicense.purchaseAmount;
                        }
                    }
                }

                for (let chargedLicense of input.license.chargedLicense) {
                    if (chargedLicense.newValue > 0) {
                        chargedLicenseUpdateParam.push({type: chargedLicense.type , totalQuantity: chargedLicense.newValue, addQuantity: chargedLicense.newValue});
                        totalAmount += chargedLicense.purchaseAmount;
                    }
                }
            } else {
                let numberLicense = input.license.numberLicense[0];
                let addQuantity = 0;
                if (numberLicense.newValue > numberLicense.orgValue) {
                    addQuantity = numberLicense.newValue - numberLicense.orgValue;
                }
                numberLicenseUpdateParam.push({type: numberLicense.type , totalQuantity: numberLicense.newValue, addQuantity: addQuantity, originalQuantity: numberLicense.orgValue});
            }

            if ((numberLicenseUpdateParam.length == 0) &
                (usageLicenseUpdateParam.length == 0) &
                (chargedLicenseUpdateParam.length == 0)) {
                commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_no_change_information"));
                loadingScreen.close();
                return;
            }

            let purchaseLicenseParam = {
                    orderInfo: orderInfo,
                    number: numberLicenseUpdateParam ,
                    recurring: usageLicenseUpdateParam ,
                    charge: chargedLicenseUpdateParam
            }
            this.purchaseLicense(purchaseLicenseParam,loadingScreen);
        },
        purchaseLicense(purchaseLicenseParam,loadingScreen) {
            let self = this;
            server.post('/purchaselicense',purchaseLicenseParam
            ).then((res) => {
                loadingScreen.close();
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_license_purchased"));
                    self.$emit('loadTenantInfo');
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_PENDING:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_not_confirmed_settlement"));
                            self.pendingOnline = true;
                            break;
                        case constants.STATUS_ERROR_ALREADY_EXISTED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_license_already_purchased"));
                            self.$emit('loadTenantInfo');
                            break;
                        case constants.STATUS_BUSY:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_license_already_changed"));
                            self.$emit('loadTenantInfo');
                            break;
                        case constants.STATUS_ERROR_EXTERNAL_SYSTEM:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_other_system").replace("{functionName}","purchaseLicense").replace("{code}",res.data.errorInfo));
                            self.checkPendingCreditProcess();
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","purchaseLicense").replace("{code}",res.data.status));
                            self.checkPendingCreditProcess();
                            break;
                    }
                    self.setDisabledOnlinePaymentStatus();
                    return;
                }
            })
            .catch( function ( error ) {
                loadingScreen.close();
                commonUtil.putExceptionErrorMessage(self, "purchaseLicense", error);
                self.checkPendingCreditProcess();
            });
        },
        resetPendingCreditProcess() {
            let self = this;

            const loadingScreen = this.$loading({
                    lock: true ,
                    text: 'Check Credit payment process ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0.7)'
            });

            server.post('/purchaselicensependingreset')
            .then((res) => {
                loadingScreen.close();
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_license_changed"));
                        self.pendingOnline = false;
                        self.$emit('loadTenantInfo');
                        break;
                    case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_settlement_nof_complete"));
                        self.pendingOnline = false;
                        break;
                    case constants.STATUS_ERROR_EXTERNAL_SYSTEM:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_other_system").replace("{functionName}","resetPendingCreditProcess").replace("{code}",res.data.errorInfo));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","resetPendingCreditProcess").replace("{code}",res.data.status));
                        break;
                }
                self.setDisabledOnlinePaymentStatus();
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "resetPendingCreditProcess", error);
            });
        },
        checkPendingCreditProcess() {
            let self = this;
            server.post('/checkpendingcreditpayment'
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        self.pendingTransactionList = res.data.pendingInfo;
                        if (self.pendingTransactionList.length == 0) {
                            self.pendingOnline = false;
                            self.pendingClosing = false;
                        } else {
                            for (let pendingProcess of self.pendingTransactionList) {
                                if (pendingProcess.orderId.indexOf("P") === 0) {
                                    self.pendingPaymentMethod = constants.BILLING_PAID;
                                } else {
                                    self.pendingPaymentMethod = constants.BILLING_CREDIT_CARD;
                                }
                                if (pendingProcess.requestType == constants.PURCHASE_REQUEST_AUTO_UPDATE) {
                                    self.pendingClosing = true;
                                } else {
                                    self.pendingOnline = true;
                                }
                            }
                        }
                        self.setDisabledOnlinePaymentStatus();
                        return ;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","checkPendingCreditProcess").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "checkPendingCreditProcess", error);
            });
        },
        confirmAgree() {
            this.showConfirmGeneral = false;
            let newStatus;
            switch(this.appData.basicContract.state) {
                case constants.CONTRACT_ACTIVE :
                    newStatus = constants.CONTRACT_NOUPDATE;
                    break;
                case constants.CONTRACT_NOUPDATE:
                    newStatus = constants.CONTRACT_ACTIVE;
                    break;
            }

            let self = this;
            server.post('/modifycontractstatus' , {tenantId: this.appData.tenantList[0].tenantId , newStatus: newStatus}
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_renewal_status_changed"));
                        self.$emit('loadTenantInfo');
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","confirmAgree").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "confirmAgree", error);
            });
        },
        moveToGroupAndUser() {
            this.showPurchaseNewLicense = false;
            this.showPurchaseLicense = false;
            this.appData.selectedMenu = "user";
            this.$router.push("/");
        },
        getUnitPrice(licenseType,priceType) {
            for (let price of this.priceList) {
                if (price.type == licenseType) {
                    switch(priceType) {
                        case "month" :
                            return price.monthPrice;
                        case "year" :
                            return price.yearPrice;
                        case "charge" :
                            return price.usagePrice;
                    }
                }
            }
        },
        getPriceOfPlan(planType) {
            for (let price of this.priceList) {
                if (price.type == planType) {
                    return price;
                }
            }
        },
        getLicenseName(licenseType) {
            return commonUtil.getLicenseName(this.$i18n, licenseType);
        },
        getLicenseUnit(licenseType) {
            return commonUtil.getLicenseUnit(licenseType);
        },
        getUnitName(licenseType) {
            return commonUtil.getUnitName(this.$i18n, licenseType);
        },
        getUnitNameForCurrent(licenseType) {
            return commonUtil.getUnitNameForCurrent(this.$i18n, licenseType);
        },
        getDisplayContractName(purchasePeriodType) {
            let displayPurchasePeriodType = commonUtil.getMessageText(this.$i18n, "item_contract_type") + "：" + commonUtil.getPurchasePeriodTypeName(this.$i18n, purchasePeriodType);
            if ((this.appData.onlinePurchase) && ((this.appData.basicContract.state === constants.CONTRACT_ACTIVE) || (this.appData.basicContract.state === constants.CONTRACT_NOUPDATE))) {
                // BILLING_TRANSFER(振り込み)はクレジット決済エラー時の一時的な対応のため、ユーザにはクレジット決済のまま表示する
                if (this.appData.basicContract.billingType === constants.BILLING_CREDIT_CARD || this.appData.basicContract.billingType === constants.BILLING_TRANSFER) {
                    return displayPurchasePeriodType + " (" + commonUtil.getMessageText(this.$i18n, "item_billing_credit_card") + ")";
                } else {
                    return displayPurchasePeriodType + " (" + commonUtil.getMessageText(this.$i18n, "item_billing_paid") + ")";
                }
            } else {
                return displayPurchasePeriodType;
            }
        },
        getPurchasePeriodTypeName(purchasePeriodType) {
            return commonUtil.getPurchasePeriodTypeName(this.$i18n, purchasePeriodType);
        },
        getContractStatusName(state) {
            return commonUtil.getMessageText(this.$i18n, "item_contract_status") + "：" + commonUtil.getContractStatusName(this.$i18n, state);
        },
        getNextFlushDateName(purchasePeriodType) {
            return commonUtil.getNextFlushDateName(this.$i18n, purchasePeriodType);
        },
        getDisplayExpireDateTime(purchasePeriodType) {
            if (purchasePeriodType == constants.PURCHASE_PERIOD_TRIAL) {
                return new Date(this.appData.basicContract.startDatetime).toLocaleString();
            } else {
                return new Date(this.appData.basicContract.nextFlushDatetime).toLocaleString();
            }
        },
        getDisplayStartDateTime(purchasePeriodType) {
            return new Date(this.appData.basicContract.startDatetime).toLocaleString();
        },
        getDisplayDateTime(datetime) {
            return new Date(datetime).toLocaleString();
        },
        getDisplayPlanName() {
            switch(this.appData.basicContract.planType) {
                case constants.LICENSE_PLAN_TALK_LITE:
                    return "Talk Lite";
                case constants.LICENSE_PLAN_TALK_ENT:
                    return "Talk Enterprise";
                case constants.LICENSE_PLAN_LIVE_LITE:
                    return "Livecast Lite";
                case constants.LICENSE_PLAN_LIVE_ENT:
                    return "Livecast Enterprise";
                case constants.LICENSE_PLAN_LIGHT:
                    return "Lite"
                case constants.LICENSE_PLAN_STANDARD:
                    return "Standard"
                case constants.LICENSE_PLAN_ENTERPRISE:
                    return "Enterprise"
            }
        },
        getPurchaseContractActionName(contractState) {
            return commonUtil.getPurchaseContractActionName(this.$i18n, contractState);
        },
        getChargedVolume (licenseType , purchaseUnit) {
            let purchaseVolume;
            switch(Number(licenseType)) {
                case constants.CHARGE_SPEECH_TEXT:
                    purchaseVolume = purchaseUnit * constants.PURCHASE_UNIT_SPEECH_TEXT;
                    break;
                case constants.CHARGE_TRANSLATION:
                    purchaseVolume = purchaseUnit * constants.PURCHASE_UNIT_TRANSLATE;
                    break;
                case constants.CHARGE_DATA_TRANSFER:
                    purchaseVolume = purchaseUnit * constants.PURCHASE_UNIT_DATA_TRANSFER / constants.PURCHASE_UNIT_DATA_TRANSFER;
                    break;
            }
            return purchaseVolume;
        },
        getDescriptionOfCurrent() {
            return commonUtil.getMessageText(this.$i18n,"item_license_assigned_count");
        },
        getTooltipOfCurrent() {
            switch(this.appData.basicContract.state) {
                case constants.CONTRACT_TERMINATE:
                    return commonUtil.getMessageText(this.$i18n,"hint_license_current_terminated");
                case constants.CONTRACT_TRIAL_END:
                    return commonUtil.getMessageText(this.$i18n,"hint_license_current_trial");
                default:
                    return commonUtil.getMessageText(this.$i18n,"hint_license_current");
            }
        },
        getDescriptionOfPurchasedCount() {
            if (this.appData.basicContract.state == constants.CONTRACT_TERMINATE) {
                return commonUtil.getMessageText(this.$i18n,"item_license_purchased_count1");
            } else {
                return commonUtil.getMessageText(this.$i18n,"item_license_purchased_count2");
            }
        },
        getTooltipOfPurchasedCount() {
            if (this.appData.basicContract.state == constants.CONTRACT_TERMINATE) {
                return commonUtil.getMessageText(this.$i18n,"hint_license_pastMax_terminate");
            } else {
                return commonUtil.getMessageText(this.$i18n,"hint_license_pastMax");
            }
        },
        getDescriptionOfAvailableCount() {
            if (this.appData.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_TRIAL) {
                return commonUtil.getMessageText(this.$i18n,"item_license_trial_count");
            } else {
                return commonUtil.getMessageText(this.$i18n,"item_license_usable_count");
            }
        },
        getTooltipOfAvailableCount() {
            if (this.appData.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_TRIAL) {
                if (this.appData.basicContract.state == constants.CONTRACT_TRIAL_END) {
                    return commonUtil.getMessageText(this.$i18n,"hint_license_pastMax_trial_end");
                } else {
                    return commonUtil.getMessageText(this.$i18n,"hint_license_pastMax_trial");
                }
            } else {
                return commonUtil.getMessageText(this.$i18n,"hint_license_currentMax");
            }
        },
        getPurchaseCommandName() {
            if (this.isAlreadyPurchased()) {
                return commonUtil.getMessageText(this.$i18n,"action_change_license");
            } else {
                return commonUtil.getMessageText(this.$i18n,"action_purchase_license");
            }
        },
        getContractChangeCommandName() {
            let switchTo;
            if (this.appData.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                switchTo = this.getPurchasePeriodTypeName(constants.PURCHASE_PERIOD_YEARLY);
            } else {
                switchTo = this.getPurchasePeriodTypeName(constants.PURCHASE_PERIOD_MONTHLY);
            }
            if (this.contractChangeOperation == null) {
                return commonUtil.getMessageText(this.$i18n,"action_change_contract").replace("{contract}",switchTo);
            } else {
                return commonUtil.getMessageText(this.$i18n,"action_change_contract_cancel").replace("{contract}",switchTo);
            }
        },
        getContractChangeNotice() {
            let nextFlushDatetime = this.getDisplayExpireDateTime(this.appData.basicContract.purchasePeriodType);
            let from = this.getPurchasePeriodTypeName(this.appData.basicContract.purchasePeriodType);
            let to;
            switch(this.appData.basicContract.purchasePeriodType) {
                case constants.PURCHASE_PERIOD_MONTHLY:
                    to = this.getPurchasePeriodTypeName(constants.PURCHASE_PERIOD_YEARLY);
                    break;
                case constants.PURCHASE_PERIOD_YEARLY:
                    to = this.getPurchasePeriodTypeName(constants.PURCHASE_PERIOD_MONTHLY);
                    break;
            }
            return commonUtil.getMessageText(this.$i18n,"info_change_contract_notice").replace("{contractDate}",nextFlushDatetime).replace("{from}",from).replace("{to}",to)
        },
        getAvailableCount(license) {
            switch(license.type) {
                case constants.LICENSE_SPEECH_TEXT :
                    if (this.appData.enableSpeechTextTrial) {
                        return this.appData.numberContract[0].currentMax;
                    }
                    break;
                case constants.LICENSE_TRANSLATION:
                    if (this.appData.enableTranslationTrial) {
                        return this.appData.numberContract[0].currentMax;
                    }
                    break;
                case constants.LICENSE_CONFIG :
                    if (this.appData.enableConfigTrial) {
                        return this.appData.numberContract[0].currentMax;
                    }
                    break;
                case constants.LICENSE_TRACKING :
                    if (this.appData.enableTrackingTrial) {
                        return this.appData.numberContract[0].currentMax;
                    }
                    break;
                case constants.LICENSE_MAP_TALK :
                    if (this.appData.enableMaptalkTrial) {
                        return this.appData.numberContract[0].currentMax;
                    }
                    break;
                case constants.LICENSE_VIDEO :
                    if (this.appData.enableVideoTrial) {
                        return this.appData.numberContract[0].currentMax;
                    }
                    break;
                case constants.LICENSE_SAML :
                    if (this.appData.enableSamlTrial) {
                        return this.appData.numberContract[0].currentMax;
                    }
                    break;
                case constants.OFF_PLAN_LICENSE_BELL :
                    // The number of Bell licenses is not tied to the number of user licenses
                    break;
                default:
                    break;
            }
            return license.currentMax;
        },
        getBaseUsage(usageLicense) {
            let numberOfUser = 0;
            for (let numberLicense of this.appData.numberContract) {
                if (numberLicense.type == constants.LICENSE_USER) {
                    numberOfUser = numberLicense.pastMax;
                    break;
                }
            }
            return usageLicense.baseUnit * numberOfUser;
        },
        getRecurring(usageLicense) {
            switch(usageLicense.type) {
                case constants.RECURRING_SPEECH_TEXT:
                    return usageLicense.recurring;
                case constants.RECURRING_TRANSLATION:
                    return usageLicense.recurring;
                case constants.RECURRING_DATA_TRANSFER:
                    return usageLicense.recurring / constants.PURCHASE_UNIT_DATA_TRANSFER;
            }
        },
        setDisabledOnlinePaymentStatus() {
            if (this.pendingOnline || this.pendingClosing || this.pendingPaidReview) {
                this.disableOnlinePayment = true;
                return;
            } else {
                if (this.appData.basicContract !== null) {
                    if (this.paidDisable && ((this.appData.basicContract.state === constants.CONTRACT_ACTIVE) || (this.appData.basicContract.state === constants.CONTRACT_NOUPDATE))) {
                        this.disableOnlinePayment = true;
                        return;
                    }
                    if (this.appData.basicContract.billingType === constants.BILLING_TRANSFER) {
                        this.disableOnlinePayment = true;
                        return;
                    }

                }
            }
            this.disableOnlinePayment = false;
        },
        showCurrentValue(license) {
            // 専用サーバーのライセンスは割り当てをしないため、表示しない
            return license.type !== constants.OFF_PLAN_LICENSE_DEDICATED;
        },
        showPurchasedCount() {
            return this.appData.basicContract.purchasePeriodType != constants.PURCHASE_PERIOD_TRIAL;
        },
        showAvailableCount() {
            return this.appData.basicContract.state != constants.CONTRACT_TERMINATE;
        },
        showPlanDescriptionDialog(selectedPlanType) {
            this.selectedPlanType = selectedPlanType;
            this.showLicensePlanDescription = true;
        },
        isActivePlan() {
            switch(this.appData.basicContract.state) {
                case constants.CONTRACT_TERMINATE:
                case constants.CONTRACT_TRIAL_END:
                case constants.CONTRACT_DISABLED:
                    return false;
                default:
                    return true;
            }
        },
        isChargeLicense(licenseType) {
            return commonUtil.isChargeLicense(licenseType);
        },
        isTrialOnPurchasedContract(licenseType) {
            if (!this.isAlreadyPurchased()) {
                return false;
            }
            switch(licenseType) {
                case constants.LICENSE_USER :
                case constants.LICENSE_ACCESS_LOG :
                case constants.LICENSE_HISTORY_RETENTION :
                case constants.LICENSE_HISTORY_RETENTION_ADVANCED :
                case constants.LICENSE_HISTORY_RETENTION_TRACKING :
                    break;
                case constants.LICENSE_CONFIG :
                    if (this.appData.enableConfigTrial) {
                        return true;
                    }
                    break;
                case constants.LICENSE_TRACKING :
                    if (this.appData.enableTrackingTrial) {
                        return true;
                    }
                    break;
                case constants.LICENSE_MAP_TALK :
                    if (this.appData.enableMaptalkTrial) {
                        return true;
                    }
                    break;
                case constants.LICENSE_SPEECH_TEXT :
                    if (this.appData.enableSpeechTextTrial) {
                        return true;
                    }
                    break;
                case constants.LICENSE_TRANSLATION:
                    if (this.appData.enableTranslationTrial) {
                        return true;
                    }
                    break;
                case constants.LICENSE_VIDEO:
                    if (this.appData.enableVideoTrial) {
                        return true;
                    }
                    break;
                case constants.LICENSE_SAML:
                    if (this.appData.enableSamlTrial) {
                        return true;
                    }
                    break;
                case constants.OFF_PLAN_LICENSE_BELL:
                    if (this.appData.enableBellTrial) {
                        return true;
                    }
                    break;
            }
            return false;
        },
        isEnableFunction(licenseType) {
            switch(licenseType) {
                case constants.LICENSE_USER :
                case constants.LICENSE_CONFIG :
                case constants.LICENSE_ACCESS_LOG :
                case constants.LICENSE_TRACKING :
                case constants.LICENSE_MAP_TALK :
                case constants.LICENSE_HISTORY_RETENTION :
                case constants.LICENSE_HISTORY_RETENTION_ADVANCED :
                case constants.LICENSE_HISTORY_RETENTION_TRACKING :
                case constants.LICENSE_SAML :
                case constants.OFF_PLAN_LICENSE_BELL :
                case constants.OFF_PLAN_LICENSE_DEDICATED :
                    return true;
                case constants.LICENSE_SPEECH_TEXT :
                    for (let usageLicense of this.appData.usageContract) {
                        if (usageLicense.type == constants.RECURRING_SPEECH_TEXT) {
                            if (usageLicense.currentValue > 0) {
                                return true;
                            }
                        }
                    }
                    break;
                case constants.LICENSE_TRANSLATION:
                    for (let usageLicense of this.appData.usageContract) {
                        if (usageLicense.type == constants.RECURRING_TRANSLATION) {
                            if (usageLicense.currentValue > 0) {
                                return true;
                            }
                        }
                    }
                    break;
                case constants.LICENSE_VIDEO:
                    for (let usageLicense of this.appData.usageContract) {
                        if (usageLicense.type == constants.RECURRING_DATA_TRANSFER) {
                            if (usageLicense.currentValue > 0) {
                                return true;
                            }
                        }
                    }
                    break;
            }
            return false;
        },
        isAlreadyPurchased() {
            if (this.appData.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_TRIAL) {
                return false;
            }
            if (this.appData.basicContract.state == constants.CONTRACT_TERMINATE) {
                return false;
            }
            return true;
        },
        isEnablePurchase() {
            if (this.appData.basicContract.billingType != constants.BILLING_PAPER) {
                return true;
            } else {
                return false;
            }
        },
        isAutoUpdateContract() {
            if (this.appData.basicContract.state == constants.CONTRACT_ACTIVE) {
                return true;
            } else {
                return false;
            }
        },
        isEnableOption() {
            // hide usageContract license if numberContract has not purchased.
            // (prepare to plan purchasing)
            for (let numberContract of this.appData.numberContract) {
                if (numberContract.type == constants.LICENSE_SPEECH_TEXT) {
                    if (numberContract.pastMax > 0) {
                        return true;
                    }
                }
            }
            return false;
        },
        isTrial() {
            if (this.appData.basicContract.purchasePeriodType == constants.PURCHASE_PERIOD_TRIAL) {
                return true;
            } else {
                return false;;
            }
        },
        isSeparately() {
            if (this.appData.basicContract.planType == constants.LICENSE_PLAN_SEPARATE) {
                return true;
            } else {
                return false
            }
        }
    },
    created: function() {
        this.getPriceInfo();
        if (this.appData.tenantList.length > 0) {
            this.primaryOwner = this.appData.tenantList[0].primaryOwner;
            this.getUserRights();
            this.getContractChangeOperation(this.appData.tenantList[0].tenantId);
        }
        if (this.appData.basicContract != null) {
            if (this.appData.basicContract.state === constants.CONTRACT_PAID_REVIEW) {
                this.pendingPaidReview = true;
            }
            this.checkPaidMemberStatus();
        }
        this.setDisabledOnlinePaymentStatus();
        this.checkPendingCreditProcess();
    },
    mounted: function() {
        window.dataLayer.push({
                               event: 'FireVirtualPV',
                               category: "License",
                               "content-name": window.location.pathname,
                               "content-view-name": "license"
                           });
    },
    computed: {
        disablePurchasingOption: function() {
            // purchasing of option license will be disabled when speech to text option has not purchased.
            for (let numberContract of this.appData.numberContract) {
                if (numberContract.type == constants.LICENSE_SPEECH_TEXT) {
                    if (numberContract.currentMax > 0) {
                        return false;
                    }
                }
            }
            return true;
        },
        currencyYen: function() {
            return true;
            /*
            /*
            if (this.appData.countryCodeAlpha3 == "JPN") {
                return true;
            } else {
                return false;
            }
            */
        },
        planLicenseContract: function() {
            return this.appData.numberContract.filter(license => !commonUtil.isOffPlanLicense(license.type));
        },
        offPlanLicenseContract: function() {
            return this.appData.numberContract.filter(license => commonUtil.isOffPlanLicense(license.type));
        },
    },
    watch: {
        'appData.tenantList'(newVal) {
            this.primaryOwner = this.appData.tenantList[0].primaryOwner;
            this.getUserRights();
            this.getContractChangeOperation(this.appData.tenantList[0].tenantId);
        },
        'appData.basicContract'(newVal) {
            if (this.appData.basicContract.state === constants.CONTRACT_PAID_REVIEW) {
                this.pendingPaidReview = true;
            }
            this.checkPaidMemberStatus();
            this.setDisabledOnlinePaymentStatus();
        },
        '$route' (to, from) {
            if (to.name == "License") {
                this.primaryOwner = this.appData.tenantList[0].primaryOwner;
                this.getUserRights();
                this.getContractChangeOperation(this.appData.tenantList[0].tenantId);
                this.$emit('loadLicenseInfo',this.appData.tenantList[0].tenantId);
            }
        }
    },
    components: {
        ConfirmGeneral ,
        confirmchangecontracttype: ConfirmChangeContractType ,
        ConfirmChangePlanType,
        LicensePlanCard,
        LicensePlanDescription,
        purchaselicense: PurchaseLicense ,
        purchasenewlicense: PurchaseNewLicense
    },
    props: ['appData']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.alertfield {
    margin-left: -10px;
    margin-top: -10px;
    width: calc(100% + 20px);
}
.alertrecord {
    background-color: #d55169;
    color: #ffffff;
    text-align: center;
    display: table-cell;
    height: 40px;
    padding-top: 10px;
}

.el-button.auto-update {
    font-size: 14px;
    color: #5171cb;
    border: none;
}
.el-button.auto-update:hover {
    background: transparent;
}
.el-button.auto-update-disabled {
    font-size: 14px;
    border: none;
    background: transparent;
    color: #848991;
    cursor: not-allowed;
}

.el-inputpartner {
    width: 400px;
}
.el-inputcontractdate {
    width: 200px;
}
.license-change-title {
    padding: 5px;
}
.license-change-input {
    padding-top: 5px;
    padding-bottom: 5px;
}
.license-description {
    padding: 5px;
    font-size: 12px;
}
.popup-box-command {
    padding-top: 5px;
    padding-bottom: 5px;
    text-align: center;
}

.license-table {
    margin: 20px 30px;
}
.license-title-box {
    width: 100%;
    background-color: #f6f6f6;
    display: table;
    border-bottom: 1px #fff solid;
}
.license-title-box-left {
    padding: 10px 0 10px 28px;
    width: 50%;
    display: table-cell;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}
.license-title-box-right {
    padding: 10px 28px 10px 28px;
    position: relative;
    width: 50%;
    display: table-cell;
    text-align : right;
    vertical-align: middle;
    font-size: 12px;
}

.selectedrecord {
    width: 100%;
    border-bottom:1px #eee solid;
    background-color: #ecf1fa;
}

.contractMode-record {
    padding-top: 10px;
    padding-bottom: 10px;
    display: block;
}

.icon-contract-status {
    height: 20px;
    padding-left: 10px;
    padding-right: 10px;
    display: inline-block;
    vertical-align: middle;
}
</style>
